import _ from 'lodash';
import React, { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { layoutDefaults } from '../../utils/layout-defaults';
import { ModalBodyButton } from '../modal/modal-body-button';
import { ModalBodyDivider } from '../modal/modal-body-divider';
import languageIconData from './languages.json';

const emphasisDelay = 600;

function ChangeLangBody({ selectedLanguage, availableLanguages, onClick }) {
  const loadingRef = useRef(false);
  const lottieRef = useRef();
  const { t } = useTranslation();
  const classes = useStyles();

  const otherLanguages = useMemo(
    () =>
      availableLanguages.filter(
        (available) => available.tag !== selectedLanguage.tag
      ),
    [availableLanguages, selectedLanguage]
  );

  useEffect(() => {
    _.delay(
      () => {
        if (!loadingRef.current) {
          lottieRef.current?.play();
        }
      },
      400 * (otherLanguages.length + 1)
    );
  }, [otherLanguages]);

  const handleOnClick = (lang) => {
    onClick?.call(this, lang);
  };

  const handleOnPrepareForClick = () => {
    if (loadingRef.current) {
      return false;
    }

    lottieRef.current?.pause();
    loadingRef.current = true;

    return layoutDefaults.keyboardDuration;
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Lottie
          ref={lottieRef}
          speed={1.3}
          loop
          animationData={languageIconData}
          className={classes.icon}
        />
      </div>
      <div>
        {/* TODO: traduzir o "ou" */}

        <ModalBodyButton
          icon={selectedLanguage.flag}
          emphasisIndex={otherLanguages.length + 1}
          emphasisDelay={emphasisDelay}
          onClick={(setLoadingLang) =>
            handleOnClick(selectedLanguage, setLoadingLang)
          }
          onPrepareForClick={() => handleOnPrepareForClick(selectedLanguage)}
          selected
        >
          {t(selectedLanguage.tag)}
        </ModalBodyButton>

        <ModalBodyDivider buttonBelow title="ou" />
        {otherLanguages.map((lang, index) => (
          <ModalBodyButton
            icon={lang.flag}
            emphasisIndex={otherLanguages.length - index}
            emphasisDelay={emphasisDelay}
            onClick={(setLoadingLang) => handleOnClick(lang, setLoadingLang)}
            onPrepareForClick={() => handleOnPrepareForClick(lang)}
          >
            {t(lang.tag)}
          </ModalBodyButton>
        ))}
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {},
  header: {
    marginTop: -layoutDefaults.bigVerticalMargin,
    marginBottom: -layoutDefaults.smallVerticalMargin,
  },
  icon: {
    height: 180,
  },
});

export { ChangeLangBody };
